import { CallToActionSection } from './view';

export default CallToActionSection;
